import ACTIONS from '@/store/storeActions';
import RunDetailsRestModel from '@/api/RestModels/run';
import LoadingState from '@/api/LoadingState';

export default class Run {
  constructor(store) {
    this.$store = store;
  }

  /**
   * @param [pathExtension]
   * @return {Promise<unknown>}
   */
  async get(pathExtension = undefined) {
    // set LoadingState to Loading
    this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.LOADING })
    try {
      // fetch runDetails
      const runDetails = await RunDetailsRestModel.get(pathExtension);
      // update signalR Exercise && exerciseDocuments here if the pathExtension is 'candidate'
      // if (pathExtension === 'candidate') {
      //   this.$store.dispatch(ACTIONS.SIGNAL_R__HANDLE_EXERCISE_CHANGE, {
      //     participantId: runDetails.candidate.id,
      //     exerciseId: runDetails.selectedExerciseId,
      //     eventType: 'ExerciseAdded'
      //   })
        // todo add initial documents
        // this.$store.dispatch(ACTIONS.SIGNAL_R__HANDLE_DOCUMENT_CHANGE, {
        //   participantId: runDetails.candidate.id,
        //   exerciseId: runDetails.selectedExerciseId,
        //   documentId: runDetails.
        //   eventType: 'DocumentAdded'
        // })
      // }
      // set runDetails and all resulting data entries
      this.$store.dispatch(ACTIONS.SET_RUN_INFO, runDetails);

      // if no error occures, set LoadingState to LOADED
      this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.LOADED })
      // return rundetails
      return runDetails
    } catch (err) {
      // if an error occurs set LoadingState to Failed
      this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runInfo', loadingState: LoadingState.FAILED })
      return err;
    }
  }

  async getParticipantStatus() {
    try {
      const participants = await RunDetailsRestModel.getParticipantStatus();
      this.$store.dispatch(ACTIONS.SET_PARTICIPANT_STATUS, participants);
      return participants;
    } catch (err) {
      return err;
    }
  }

  /**
   * @param {Array<string>} infoFragments
   */
  async getInfo(infoFragments) {
    const self = this;
    try {
      self.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, LoadingState.LOADING)
      // build query
      let query = '';
      if (Array.isArray(infoFragments) && infoFragments.length > 0) {
        query = `?expands=${infoFragments.join('&expands=')}`;
      }
      const info = await RunDetailsRestModel.getInfo(query);
      if (info) self.$store.dispatch(ACTIONS.SET_RUN_INFO, info);
      return info
    } catch (err) {
      return err;
    }
  }

  async getDocumentNames() {
    try {
      this.$store.dispatch(ACTIONS.SET_RUN_INFO_LOADINGSTATE, { type: 'runDocuments', payload: LoadingState.LOADING })
      const data = await RunDetailsRestModel.getDocumentNames();
      this.$store.dispatch(ACTIONS.SET_RUN_DOCUMENTS, data);
      return data;
    } catch (err) {
      console.error(err);
      return err;
    }
  }

  async getDocument(path) {
    try {
      const data = await RunDetailsRestModel.getDocument(path);
      return data
    } catch (err) {
      console.error(err);
      return err;
    }

  }
}
